<template>
  <label>
    <span v-if="labelPos == 'left' && label" class="mr-1">
      {{ label }}
    </span>
    <input
      :id="randomId"
      type="text"
      :class="[disabled ? defaultDisabledClasses : defaultClasses]"
      :disabled="disabled"
      v-model="model"
    />
    <span v-if="labelPos == 'right' && label" class="ml-1">
      {{ label }}
    </span>
  </label>
</template>

<script>
export default {
  name: "TimeTrackingTextfield",
  props: {
    // text: String,
    // iconText: String,
    // tooltipText: String,
    labelPos: {
      default: 'left',
      // eslint-disable-next-line no-unused-vars
      validator(value, props) {
        return ['left', 'right'].includes(value)
      }
    },
    label: String,
    modelValue: String,
    disabled: Boolean,
  },
  created() {
    this.randomId = this.uuidv4()
  },
  data() {
    return {
      defaultClasses: "border-black border-1 w-48 pl-1",
      defaultDisabledClasses: "border-gray-500 border-1 w-48 bg-gray-200 pl-1",
    }
  },
  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit("update:modelValue", value)
      },
    },
  },
  methods: {
    uuidv4() {
      return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (
          +c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
        ).toString(16)
      )
    },
  },
}

</script>
